import React from 'react';
import { useTranslation } from 'react-i18next';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';

import scss from './EmptySessionsDisclaimer.module.scss';

function EmptySessionsDisclaimer() {
  const { t } = useTranslation('story');

  return (
    <div className={scss.wrapper}>
      <HistoryOutlinedIcon className={scss.icon} />
      <span className={scss.title}>{t('noSessionsYet')}</span>
      <span className={scss.description}>{t('emptySessionsDescription')}</span>
    </div>
  );
}

export default EmptySessionsDisclaimer;
